class NodeAttributesUI {

  constructor({ canvas, nodeId }) {
    if (!(canvas && nodeId)) {
      throw new Error(`canvas and nodeId are required`);
    }
    this.setCanvas(canvas);
    this.node = this.store.getNode(nodeId);
    if (!this.node) {
      throw new Error(`no such node ${nodeId}`);
    }
    this.nodeId = nodeId;
    this.attributes = this.node.attributes;
    this.roles = this.node.roles;
  }

  setCanvas(canvas) {
    this.canvas = canvas;
    this.store = canvas.store;
    this.operation = canvas.operation;
  }

  addRole(role) {
    if (this.node.addRole(role)) {
      this.operation.addMapNodeRole({
        nodeId: this.nodeId,
        role,
        onFailure: this.onFailure.bind(this),
      });
    } else {
      console.log(`addRole ${role} failed`);
    }
    this.update();
  }

  removeRole(role) {
    if (this.node.removeRole(role)) {
      this.operation.removeMapNodeRole({
        nodeId: this.nodeId,
        role,
        onFailure: this.onFailure.bind(this),
      });
    } else {
      console.log(`removeRole ${role} failed`);
    }
    this.update();
  }

  getRoles() {
    return this.roles;
  }

  onFailure(res) {
    console.log(`operation failed: ${res}`);
  }

  getAttributes() {
    return this.node.attributes;
  }

  addAttribute({ role, name, value, operationMessages }) {
    const attrId = this.node.addAttribute({ role, name, value });
    if (attrId) {
      this.update();
      if (operationMessages) {
        const message = this.operation.messages.addMapNodeAttribute({
          uuid: attrId,
          mapNodeUUID: this.nodeId,
          role,
          name,
          value,
        });
        operationMessages.push(message);
      } else {
        this.operation.addMapNodeAttribute({
          uuid: attrId,
          mapNodeUUID: this.nodeId,
          role,
          name,
          value,
          onFailure: this.onFailure.bind(this),
        });
      }

    } else {
      console.log(`addAttribute ${role}:${name}:${value} failed`);
    }
  }

  editAttribute({ id, nodeId, role, name, value, prevName, prevValue, operationMessages }) {
    const attrId = this.node.editAttribute({ id, role, name, value });
    if (attrId) {
      this.update();
      if (operationMessages) {
        const message = this.operation.messages.editMapNodeAttribute({
          uuid: attrId,
          mapNodeUUID: nodeId,
          role,
          name,
          value,
          prevName,
          prevValue,
        });
        operationMessages.push(message);
      } else {
        this.operation.editMapNodeAttribute({
          uuid: attrId,
          mapNodeUUID: nodeId,
          role,
          name,
          value,
          prevName,
          prevValue,
          onFailure: this.onFailure.bind(this),
        });
      }


    } else {
      console.log(`editAttribute ${role}:${name}:${value} failed`);
    }
  }

  removeAttribute({ id, nodeId, role='card', operationMessages }) {
    if (!id) return;
    const attr = this.node.getAttribute({ id, role });
    if (!attr) return;
    const attrId = this.node.removeAttribute({ id, role });
    const { name, value } = attr;
    if (attrId) {
      this.update();
      if (operationMessages) {
        const message = this.operation.messages.removeMapNodeAttribute({
          uuid: attrId,
          mapNodeUUID: nodeId,
          name,
          value,
          role,
        });
        operationMessages.push(message);
      } else {
        this.operation.removeMapNodeAttribute({
          uuid: attrId,
          mapNodeUUID: nodeId,
          name,
          value,
          role,
          onFailure: this.onFailure.bind(this),
        });
      }
    } else {
      console.log(`removeAttribute ${id} failed`);
    }
  }

  update() {
    const nodeTag = this.canvas.nodeTags[this.nodeId];
    if (nodeTag) {
      nodeTag.update({ forceUpdate: true });
      const attributesTag = nodeTag.tags['node-attributes'];
      if (attributesTag) {
        attributesTag.update();
      }
    }
    canvas.attributesTabTag.update();
    nodeTag.topLevelParentTag().rediscoverLinkPositions();
  }

}

// no singleton instance

export { NodeAttributesUI };



// WEBPACK FOOTER //
// ./starling/src/lib/node/attributes-ui.js